import { type MRT_Updater } from "material-react-table";

/** MRT hands state changes as either a value or a function of the old one; this is the new value. */
export function applyUpdater<TState>(updater: MRT_Updater<TState>, current: TState): TState {
  return typeof updater === "function" ? (updater as (old: TState) => TState)(current) : updater;
}
